import {createErrorAction} from './utils';

const TYPES = {
    GET_RETURN_PLAYERS: 'GET_RETURN_PLAYERS',
    GET_RETURN_PLAYERS_COMPLETE: 'GET_RETURN_PLAYERS_COMPLETE',
    GET_RETURN_PLAYERS_FAILED: 'GET_RETURN_PLAYERS_FAILED',
    RESET_DATA: 'RETURN_PLAYERS_RESET_DATA'
};

export default {
    TYPES,

    getReturnPlayers: payload => ({
        type: TYPES.GET_RETURN_PLAYERS,
        payload
    }),

    getReturnPlayersSuccess: payload => ({
        type: TYPES.GET_RETURN_PLAYERS_COMPLETE,
        payload
    }),

    getReturnPlayersFailed: createErrorAction(TYPES.GET_RETURN_PLAYERS_FAILED),

    resetData: () => ({
        type: TYPES.RESET_DATA
    })
};
